import React from "react";
import Head from "next/head";

export default function MetaComponent({ meta }) {
  return (
    <Head>
      <title>{meta?.title}</title>
      <meta name="description" content={meta?.description} />
    </Head>
  );
}
